module.exports = __webpack_public_path__ + "static/media/vinci.831fe7e0.svg";